import axios, { AxiosResponse } from 'axios';
import { GeneratePublicApiTokenData } from './types';
import { IPaginationConfig } from '/react4xp/parts/stats-external-admin/stats-external-admin.types';
/**
 * Получить список токенов
 * @param params
 */
export const getPublicApiTokenList = (params: IPaginationConfig): Promise<AxiosResponse> => {
    return axios.get('/services/isnaportal/api/public-api-token', { params });
};

/**
 * Сгенерировать токен
 * @param data
 */
export const generatePublicApiToken = (
    data: GeneratePublicApiTokenData
): Promise<AxiosResponse> => {
    return axios.post('/services/isnaportal/api/public-api-token', data);
};

/**
 * Заблокировать токен
 * @param id
 */
export const blockPublicApiToken = (id: string): Promise<AxiosResponse> => {
    return axios.post('/services/isnaportal/api/public-api-token/block', { id });
};

/**
 * Разблокировать токен
 * @param id
 */
export const unblockPublicApiToken = (id: string): Promise<AxiosResponse> => {
    return axios.post('/services/isnaportal/api/public-api-token/unblock', { id });
};

/**
 * Поиск данных налогоплаельщика
 * @param taxpayerCode
 */
export const findTaxpayerData = (taxpayerCode: string): Promise<AxiosResponse> => {
    return axios.get('/services/isnaportal/api/public-api-token/taxpayer-data', {
        params: { taxpayerCode },
    });
};
